/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UploadIcon = /*#__PURE__*/ createSvgIcon(
  'UploadIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.494 16c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014 14.5v-.75c0-.213.071-.39.214-.534A.72.72 0 014.746 13c.21 0 .39.072.535.216a.72.72 0 01.219.534v.75h9v-.75c0-.213.072-.39.214-.534a.72.72 0 01.532-.216c.21 0 .39.072.535.216a.72.72 0 01.219.534v.75c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493zM9.25 5.875L7.583 7.542a.73.73 0 01-.53.229.762.762 0 01-.542-.23.745.745 0 01.01-1.062l2.958-2.958a.756.756 0 01.525-.208c.1 0 .194.017.281.052a.69.69 0 01.236.156l2.958 2.958c.153.153.23.327.23.521a.733.733 0 01-.22.52.762.762 0 01-.541.23.729.729 0 01-.531-.23L10.75 5.876v6.375c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534V5.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default UploadIcon;
